import React, { useEffect, useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Checkbox, FormControlLabel, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Category } from "../../@types/Category";
import ProductCarousel from "./ProductCarrousel";
import { CategoryService } from "../../services/Category.service";
import { ProductService } from "../../services/Product.service";
import { Product } from "../../@types/Product";

const ProductsPage: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const productsData = await ProductService.getProducts();
        setProducts(productsData);
      } catch (err) {
        setError("Error al cargar los productos");
      } finally {
        setLoading(false);
      }
    };

    const loadCategories = async () => {
      try {
        const categoriesData = await CategoryService.getCategories();
        setCategories(categoriesData);
      } catch (err) {
        setError("Error al cargar las categorías");
      }
    };

    loadProducts();
    loadCategories();
  }, []);

  const handleCategoryChange = (category: string) => {
    setSelectedCategories((prevSelected) =>
      prevSelected.includes(category)
        ? prevSelected.filter((c) => c !== category)
        : [...prevSelected, category]
    );
  };

  const filteredProducts = selectedCategories.length
    ? products.filter((product) =>
        selectedCategories.some((category) => product.categories.map(cat => cat.name).includes(category))
      )
    : products;

  if (loading) return <p>Cargando productos...</p>;
  if (error) return <p>{error}</p>;

  return (
    <Box display="flex">
      <Box width="20%" mt={11} sx={{ display: { xs: "none", sm: "block" } }}>
        {categories.map((category) => (
            <Accordion key={category.id} >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>{category.name}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <FormControlLabel
              control={
                <Checkbox
                checked={selectedCategories.includes(category.name)}
                onChange={() => handleCategoryChange(category.name)}
                />
              }
              label={`Todos los productos de ${category.name}`}
              style={{ display: "block" }}
              />
              {category.subcategories.length > 0 && (
              category.subcategories.map((sub) => (
                <FormControlLabel
                key={sub.id}
                control={
                  <Checkbox
                  checked={selectedCategories.includes(sub.name)}
                  onChange={() => handleCategoryChange(sub.name)}
                  />
                }
                label={sub.name}
                style={{ display: "block" }}
                />
              ))
              )}
            </AccordionDetails>
            </Accordion>
        ))}
      </Box>
      <Box width="80%">
        <ProductCarousel products={filteredProducts} columns={6} rows={2} />
      </Box>
    </Box>
  );
};

export default ProductsPage;